import "twin.macro";

export const EmptyAppScreen = () => {
    return (
        <div tw="w-full h-full flex items-center justify-center text-center">
            <div tw="mb-12">
                <div tw="mb-4 text-icon-pale">
                    <svg
                        width="124"
                        height="123"
                        viewBox="0 0 124 123"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        tw="mx-auto">
                        <rect
                            opacity="0.5"
                            x="18"
                            y="6"
                            width="72"
                            height="96"
                            rx="8"
                            strokeWidth="2"
                            strokeLinejoin="round"
                            strokeDasharray="15 15"
                            tw="stroke-icon-xpale"
                        />
                        <rect x="33" y="20" width="72" height="96" rx="10" tw="fill-n200" />
                        <path d="M69 59L69 68M69 77L69 68M69 68L78 68L60 68" strokeWidth="2" tw="stroke-icon-pale" />
                    </svg>
                </div>
                <div tw="text-builder-2xl font-semibold text-text-base mb-0.5">No screens yet</div>
                <div tw="text-builder-lg text-text-pale">Create a screen to see it appear here.</div>
            </div>
        </div>
    );
};
